import React from 'react';

import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import defaultBlurImage from 'assets/images/blur_image.png';

import { getClosestThumbnail } from 'shared/utils/thumbnails';

const Image = ({
  placeholderSrc = defaultBlurImage,
  thumbnails = [],
  defaultImage,
  alt = '',
  src,
  ...props
}) => {
  // If image and thumbnails are passed - try to find a suitable thumbnail.
  if (!_.isEmpty(thumbnails) && !_.isNil(src)) {
    const thumbnail = getClosestThumbnail(
      thumbnails,
      _.get(props, 'width', 50),
      _.get(props, 'height', 50)
    );

    if (!_.isNil(thumbnail)) {
      src = thumbnail;
    }
  }

  if (_.isNil(src)) {
    src = defaultImage;
  }

  return (
    <LazyLoadImage
      alt={alt}
      src={src}
      placeholderSrc={placeholderSrc}
      {...props}
    />
  );
};

export default Image;
